<template>
    <div class="aboutPage">
      <div class="content-main" v-if="$store.state.webNavigator=='pc'">
        <div class="content-bar">
          <div>
            <div class="content-bar-map"></div>
            <div class="content-fotBox">
              <div class="content-leftBox displayIB">
                <div class="content-leftBox-fot">
                  <p class="font16px content-Tlt">集团总部：</p>
                  <p class="font16px content-p">Fax：400-8855-091</p>
                  <p class="font16px content-p">Add：湖南省长沙市高新开发区汇智中路179号金荣同心工业园C6栋</p>
                </div>
              </div>
              <div class="content-rightBox displayIB">
                <div class="content-ewmBar displayIB">
                  <div class="content-ewmImg ZMLgzh"></div>
                  <p class="font16px content-p">
                    扫码关注 <br>
                    脂玫乐公众号
                  </p>
                </div>
                <div class="content-ewmBar displayIB">
                  <div class="content-ewmImg ZMLApp"></div>
                  <p class="font16px content-p">
                    扫码免费下载 <br>
                    脂玫乐APP
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--    手机-->
      <div v-else class="phone-page">
        <div>
          <listTopImg :imgType="'5'"/>
        </div>
        <div class="banner-Box">
          <div class="banner-map"></div>
          <div class="banner-ewmList">
            <div class="banner-ewmBox displayIB">
              <img title="" class="banner-ewm" :src="src1" alt="">
              <p class="banner-ewmP">
                扫码免费下载 <br>
                脂玫乐APP
              </p>
            </div>
            <div class="banner-ewmBox displayIB">
              <img title="" class="banner-ewm" :src="src2" alt="">
              <p class="banner-ewmP">
                扫码关注 <br>
                脂玫乐公众号
              </p>
            </div>
          </div>
          <div class="banner-content">
            <p class="banner-tlt">集团总部：</p>
            <p class="col666666 font22phone banner-text">Fax：400-8855-091</p>
            <p class="col666666 font22phone banner-text">Add：湖南省长沙市高新开发区汇智中路179号金荣同心工业园C6栋</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'aboutPage',
  data () {
    return {
      src1:'https://jusewebapp.zmelo.com/zml-gw/v1.1.1/phone/ewm/zmlAppewm.png',
      src2:'https://jusewebapp.zmelo.com/zml-gw/v1.1.1/phone/ewm/zmlfotewm.png',
      brand: [
        {
          name: '谷医堂互联网医院',
          desc: '通过线上名医工作室，互联千万患者与中医师，提供远程医疗、线上问诊、药品配送、健康咨询等一站式服务的医疗健康生态平台。',
        },
        {
          name: '谷医堂中医馆',
          desc: '集名医问诊、康复理疗、体质调理、慢病管理、健康讲堂等中医药服务为一体的专业医疗机构，医保定点单位。尤其专长中医治疗不孕不育。',
        },
        {
          name: '谷医堂药房连锁',
          desc: '开创“药房+中医诊所”新模式，提供中药材、中西药品、医用耗材零售及中医诊疗服务。',
        },
        {
          name: '谷医堂商城',
          desc: '以中药材、中西药品经营为基础，健康保健产品经营为辅，健康管理服务咨询为拓展方向的B2C垂直电商平台。',
        },
        {
          name: '谷方益元',
          desc: '谷医堂旗下的健康调理品牌，率先在行业提出“古方为纲、名医验证、自然为本、权威研制”四合一的产品理念，致力于传承中医智慧，推广中医药产品及文化。',
        },
        {
          name: '脂玫乐',
          desc: '谷医堂旗下的健康瘦身品牌，倡导辨证施法的健康瘦身理念，由中医学医师、专家顾问团、健康管理师和公共营养师组成的专业团队，针对个体量身定制个性化瘦身方案和全程跟踪服务。',
        },
      ],
      fzlc: [
        {
          year: '2014',
          desc: '公司创立，奠定以中医为特色的“互联网+大健康”的发展道路',
        },
        {
          year: '2015',
          desc: '筹建产品研发中心，确定以高质量产品为依托的战略方向',
        },
        {
          year: '2016',
          desc: '第一项知识产权被国家专利局受理，进入专利型企业时代<br>第一款自主研发产品上市销售,在自主研发进程中迈出里程碑的一步',
        },
        {
          year: '2017',
          desc: '第一家谷医堂大药房门店落地长沙，全国连锁布局正式起航<br>与湖南省中医药研究院达成战略合作，成立700m²的战略合作实验室，踏上中医药标准化、国际化之路',
        },
        {
          year: '2018',
          desc: ' 首家谷医堂中医馆营业，线上线下全贯通的健康服务开启新篇章<br>筹建3000平方米的省级院内制剂中心，未来将扩建成为湖南省内最大的企业制剂中心',
        },
        {
          year: '2019',
          desc: '成为第一家取得互联网医院牌照的湖南企业，领跑互联网+中医药新时代<br>确定“做最专业的常见病、慢性病分病种与健康管理专家”的企业定位',
        },
      ],
      photo: [
        {
          imgUrl: 'https://jusewebapp.zmelo.com/zml-gw/315.png',
        },
        {
          imgUrl: 'https://jusewebapp.zmelo.com/zml-gw/jiameng.png',
        },
        {
          imgUrl: 'https://jusewebapp.zmelo.com/zml-gw/chuangxin.png',
        },
        {
          imgUrl: 'https://jusewebapp.zmelo.com/zml-gw/zhiliang.png',
        },
        {
          imgUrl: 'https://jusewebapp.zmelo.com/zml-gw/fuwu.png',
        },
        {
          imgUrl: 'https://jusewebapp.zmelo.com/zml-gw/youxiu.png',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("aboutPhone.less");
  }
  @media screen and (min-width: 800px) {
    @import url("about.less");
  }
</style>



// WEBPACK FOOTER //
// aboutPage.vue